// extracted by mini-css-extract-plugin
var _1 = "uJxKqn3m";
var _2 = "uJxKqn3m";
export { _1 as "icon-share", _2 as "iconShare" }
